import React from 'react';
import Patrocinadores from '../assets/imagens/Set-Assinaturas.png';
import { Grid } from '@mui/material';
import { useDevice } from 'components/DeviceContext.js';

const PatrocinioErealizacao = () => {
	const { isMobile } = useDevice();

	return (
		<Grid container style={{ padding: isMobile ? '2em' : '10em', backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
			<Grid item xs={12} md={12} lg={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '5em', backgroundColor: 'rgba(255, 255, 255, 0.8)'  }}>
				<img src={Patrocinadores} alt="img-patrocinadores" style={{ width: '80vw' }} />
			</Grid>
		</Grid>
	);
};

export default PatrocinioErealizacao;
